/* eslint-disable */
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";
import { TypedMutation } from "../mutations";
import {
  CreateProducttags,
  CreateProducttagsVariables
} from "./types/CreateProducttags";
import {
  RemoveProducttags,
  RemoveProducttagsVariables
} from "./types/RemoveProducttags";
import {
  CreateProducttagsChoice,
  CreateProducttagsChoiceVariables
} from "./types/CreateProducttagsChoice";
import {
  CreateSkutagsChoice,
  CreateSkutagsChoiceVariables
} from "./types/CreateSkutagsChoice";
import {
  UpdateProducttags,
  UpdateProducttagsVariables
} from "./types/UpdateProducttags";
import {
  ProducttagsAddCatalogues,
  ProducttagsAddCataloguesVariables
} from "./types/ProducttagsAddCatalogues";
import {
  ProducttagsDeleteCatalogues,
  ProducttagsDeleteCataloguesVariables
} from "./types/ProducttagsDeleteCatalogues";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";

const createProducttags = gql`
  mutation CreateProducttags($input: ProductTagsCreateInput!) {
    producttagsCreate(input: $input) {
      productTags {
        id
        title
        name
        stickersImage
        stickersImageLocationX
        stickersImageLocationY
        showTag
        componentFontColor
        productFontColor
        productBackgroundColor
      }
      errors: producttagsErrors {
        code
        field
      }
    }
  }
`;
// export const useHotsearchCreateMutation = makeMutation<
//   CreateProducttags,
//   CreateProducttagsVariables
// >(createProducttags);
export const TypedCreateProducttags = TypedMutation<
  CreateProducttags,
  CreateProducttagsVariables
>(createProducttags);

const removeProducttags = gql`
  mutation RemoveProducttags($id: ID!) {
    producttagsDelete(id: $id) {
      errors: producttagsErrors {
        code
        field
      }
    }
  }
`;
// export const usehotsearchDeleteMutation = makeMutation<
//   RemoveProducttags,
//   RemoveProducttagsVariables
// >(removeProducttags);
export const TypedRemoveProducttags = TypedMutation<
  RemoveProducttags,
  RemoveProducttagsVariables
>(removeProducttags);

const createProducttagsChoice = gql`
  mutation CreateProducttagsChoice(
    $producttags: [ID]!
    $productId: ID!
    $typeNumber: String!
  ) {
    producttagsChoiceCreate(
      producttags: $producttags
      productId: $productId
      typeNumber: $typeNumber
    ) {
      product {
        id
        name
      }
      errors: producttagsErrors {
        code
        field
      }
    }
  }
`;
export const useproducttagsChoiceCreateMutation = makeMutation<
  CreateProducttagsChoice,
  CreateProducttagsChoiceVariables
>(createProducttagsChoice);

const createSkutagsChoice = gql`
  mutation CreateSkutagsChoice(
    $producttags: [ID]!
    $productvariantId: ID!
    $typeNumber: String!
  ) {
    skutagsChoiceCreate(
      producttags: $producttags
      productvariantId: $productvariantId
      typeNumber: $typeNumber
    ) {
      productvariant {
        id
        name
      }
      errors: producttagsErrors {
        code
        field
      }
    }
  }
`;
export const useskutagsChoiceCreateMutation = makeMutation<
  CreateSkutagsChoice,
  CreateSkutagsChoiceVariables
>(createSkutagsChoice);

const updateProducttags = gql`
  mutation UpdateProducttags($id: ID!, $input: ProductTagsCreateInput!) {
    producttagsUpdate(id: $id, input: $input) {
      producttags {
        id
        title
        name
        stickersImage
        stickersImageLocationX
        stickersImageLocationY
        showTag
        componentFontColor
        productFontColor
        productBackgroundColor
      }
      errors: producttagsErrors {
        code
        field
      }
    }
  }
`;
export const TypedproducttagsUpdateMutation = TypedMutation<
  UpdateProducttags,
  UpdateProducttagsVariables
>(updateProducttags);

const producttagsAddCatalogues = gql`
  ${pageInfoFragment}
  mutation ProducttagsAddCatalogues(
    $producttag: ID!
    $input: TagsCatalogueInput!
    $after: String
    # $first: Int
    $last: Int
    $before: String
  ) {
    producttagsAddCatalogues(producttag: $producttag, input: $input) {
      producttagsErrors {
        field
        code
      }
      producttag {
        id
        name
        products(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              thumbnail {
                url
              }
              productType {
                name
              }
              isPublished
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
        variants(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              sku
              product {
                id
                name
              }
              skuName
              isPublished
              thumbnail {
                url
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
        categories(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              products(first: 20, before: $before, after: $after, last: $last) {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
        collections(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              products(first: 20, before: $before, after: $after, last: $last) {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
      }
    }
  }
`;
export const TypedproducttagsAddCataloguesMutation = TypedMutation<
  ProducttagsAddCatalogues,
  ProducttagsAddCataloguesVariables
>(producttagsAddCatalogues);

const producttagsDeleteCatalogues = gql`
  ${pageInfoFragment}
  mutation ProducttagsDeleteCatalogues(
    $producttagId: ID!
    $input: TagsCatalogueInput!
    # $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    producttagsDeleteCatalogues(producttagId: $producttagId, input: $input) {
      producttagsErrors {
        field
        code
      }
      productTag {
        id
        name
        products(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              thumbnail {
                url
              }
              productType {
                name
              }
              isPublished
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
        variants(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              product {
                id
                name
              }
              sku
              skuName
              isPublished
              thumbnail {
                url
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
        categories(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              products(first: 20, before: $before, after: $after, last: $last) {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
        collections(first: 20, before: $before, after: $after, last: $last) {
          edges {
            node {
              id
              name
              products(first: 20, before: $before, after: $after, last: $last) {
                totalCount
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
          totalCount
        }
      }
    }
  }
`;
export const TypedproducttagsDeleteCataloguesMutation = TypedMutation<
  ProducttagsDeleteCatalogues,
  ProducttagsDeleteCataloguesVariables
>(producttagsDeleteCatalogues);
